// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._7CqB6dCDx{display:flex;height:100%}\n", ""]);
// Exports
exports.locals = {
	"container": "_7CqB6dCDx"
};
module.exports = exports;
